import { TablePagination } from "@mui/material";
import React from "react";
import styles from "./BulkTablePagination.module.css";

const BulkTablePagination = ({ limit, page, onChangeLimit, onChangePage, totalElements = 0 }) => (
	<TablePagination
		classes={{ root: styles.table__pagination }}
		component="div"
		count={totalElements}
		page={page}
		rowsPerPage={limit}
		rowsPerPageOptions={[10, 25, 50]}
		onPageChange={onChangePage}
		onRowsPerPageChange={onChangeLimit}
	/>
);

export default BulkTablePagination;
